export const Category_Types = {
  mainCategory: 0,
  subCategory: 1,
};
export const Edit_Category_Types = {
  info: 0,
  edit: 1,
};
export const Edit_Transaction_Types = {
  info: 0,
  edit: 1,
};
export const Budget_Types = {
  monthly: 0,
  annual: 1,
};
export const NetWorth_Types = {
  assets: 0,
  liabilities: 1,
};
export const SignIn_Types = {
  signIn: 0,
  signUp: 1,
};
export const Account_Types = {
  0: 'Depository',
  1: 'Credit',
  2: 'Loan',
  3: 'Investment',
  4: 'Other',
  5: 'Undefined',
};
export const MonthsData = [
  { name: 'January', number: 1, firstDay: '01', lastDay: 31 },
  { name: 'February', number: 2, firstDay: '01', lastDay: 28 },
  { name: 'March', number: 3, firstDay: '01', lastDay: 31 },
  { name: 'April', number: 4, firstDay: '01', lastDay: 30 },
  { name: 'May', number: 5, firstDay: '01', lastDay: 31 },
  { name: 'June', number: 6, firstDay: '01', lastDay: 30 },
  { name: 'July', number: 7, firstDay: '01', lastDay: 31 },
  { name: 'August', number: 8, firstDay: '01', lastDay: 31 },
  { name: 'September', number: 9, firstDay: '01', lastDay: 30 },
  { name: 'October', number: 10, firstDay: '01', lastDay: 31 },
  { name: 'November', number: 11, firstDay: '01', lastDay: 30 },
  { name: 'December', number: 12, firstDay: '01', lastDay: 31 },
];
